import { render, staticRenderFns } from "./epm.vue?vue&type=template&id=4ff20fe2"
import script from "./epm.vue?vue&type=script&lang=ts"
export * from "./epm.vue?vue&type=script&lang=ts"
import style0 from "./epm.vue?vue&type=style&index=0&id=4ff20fe2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports